//wiliam
export default {
    parseUser({ general, access, address, contacts, permissions, tags }) {
        return {
            name: general.name,
            cpfCnpj: general.cpfCnpj,
            useType: general.useType,

            login: access.login ? access.login.trim() : "",
            password: access.password,

            cep: address.zipCode,
            state: address.state,
            city: address.city,
            neighborhood: address.neighborhood,
            address: address.streetName,
            addressNumber: address.streetNumber,
            addressComplement: address.extra,

            contacts: JSON.stringify(contacts),
            tags: tags || [],

            permissions: permissions
        };
    },
    // returnPermissionsList(checks) {
    //     let permissions = [];
    //     if (checks.permitirCriarCampanhas) {
    //         permissions.push('CREATE_CAMPAIGN');
    //     }
    //     if (checks.allowSms) {
    //         permissions.push('USE_MARKETING_MODULE');
    //     }
    //     if (checks.allowChangeTerms) {
    //         permissions.push('CUSTOMIZE_USE_TERMS');
    //     }
    //     if (checks.allowWifeedTermsDeactivate) {
    //         permissions.push('DISABLE_PLATFORM_USE_TERMS');
    //     }
    //     if (checks.allowExternalCampaignBackground) {
    //         permissions.push('USE_EXTERNAL_CAMPAIGN_BACKGROUND');
    //     }
    //     if (checks.createEstablishment) {
    //         permissions.push('CREATE_ESTABLISHMENT');
    //     }
    //     if (checks.manageUsers) {
    //         permissions.push('MANAGE_USERS');
    //     }
    //     if (checks.managePartnersUsers) {
    //         permissions.push('MANAGE_PARTNERS_USERS');
    //     }
    //     if (checks.readLeads) {
    //         permissions.push('READ_LEADS');
    //     }
    //     return permissions;
    // },

    parseEstablishmentPermissions(permissions) {
        return {
            permitirVincularAnunciantes: permissions.bindAdvertisers,
            permitirCriarCampanhas: permissions.createAdvertising,
            priorizarAnunciante: permissions.prioritizeAdvertising,
            permitirUtilizarSMS: permissions.allowSms,
            permitirCustomizarTermos: permissions.allowChangeTerms,
            permitirDesativarTermosWifeed:
                permissions.allowWifeedTermsDeactivate,
            useExternalCampaignBackground: permissions.allowExternalCampaignBackground,
            readLeads:permissions.readLeads,
            managePartnersUsers:permissions.managePartnersUsers,
            manageUsers:permissions.manageUsers,
            createEstablishment:permissions.createEstablishment,
        };
    },

    formatUser(user) {
        return {
            id: user.id,
            userId: user.userId,

            general: {
                name: user.name,
                cpfCnpj: user.cpfCnpj,
                useType: user.useType,
            },
            access: {
                login: user.login,
                password: user.password
            },

            address: {
                zipCode: user.cep,
                state: user.state,
                city: user.city,
                neighborhood: user.neighborhood,
                streetName: user.address,
                streetNumber: user.addressNumber,
                extra: user.addressComplement
            },

            lastLogin: user.lastLogin,
            loginBlocked: user.loginBlocked,

            masterUser: {
                name: user.masterName,
                email: user.masterLogin
            },

            contacts: JSON.parse(user.contacts),

            tags: user.tags || [],

            permissions: user.permissions

            // checks: {
            //     readLeads: user.permissions.find(x => x === "READ_LEADS") ? true : false,
            //     managePartnersUsers: user.permissions.find(x => x === "MANAGE_PARTNERS_USERS") ? true : false,
            //     manageUsers: user.permissions.find(x => x === "MANAGE_USERS") ? true : false,
            //     createEstablishment: user.permissions.find(x => x === "CREATE_ESTABLISHMENT") ? true : false,
            //     createAdvertising: user.permissions.find(x => x === "CREATE_CAMPAIGN") ? true : false,
            //     allowSms: user.permissions.find(x => x === "USE_MARKETING_MODULE") ? true : false,
            //     allowChangeTerms: user.permissions.find(x => x === "CUSTOMIZE_USE_TERMS") ? true : false,
            //     allowWifeedTermsDeactivate: user.permissions.find(x => x === "DISABLE_PLATFORM_USE_TERMS") ? true : false,
            //     allowExternalCampaignBackground: user.permissions.find(x => x === "USE_EXTERNAL_CAMPAIGN_BACKGROUND") ? true : false
            // },
        };
    }
};
